<script lang="ts">
  import Vue from 'vue';
  import createSimpleTransition from './transitionHelper';

  export default Vue.extend({ ...createSimpleTransition('slide-y-transition') });
</script>
